import React from 'react';
import { Link } from 'react-router-dom';

const Fostering = () => {
  return (
    <div className="fostering-container">
      <div className="image-section" data-aos="fade-down">
        <img
          src="/img/blog/speed.png"
          alt="cooperate gifting"
          className="community-image"
        />
      </div>
      <div className="content-section" data-aos="fade-right">
        <div className="category-and-title">
          <div className="metadata">
            <span className="category">Article</span>
            <span className="separator">•</span>
            <span className="read-time">2min read</span>
            <span className="separator">•</span>
            <span className="date">April 7, 2025</span>
          </div>
          <h2 className="title">Money at the Speed of Light: How Tech Is Closing the Financial Gap Between Nations
          </h2>
        </div>
        <p className="description">
        The way we send and receive money has transformed drastically over the years. What once took days...
        </p>
        <div className="author-section">
          {/* <img
            src="/img/blog/rev1.png"
            alt="Lipaworld"
            className="avatar"
          /> */}
          <span className="author-name">Lipaworld</span>
        </div>
        <Link to='/blog/money-at-the-speed-of-light' className="read-more-button"> <button className="read-more-button">Read more</button></Link>
      </div>
    </div>
  );
};

export default Fostering;
